import {
  CheckCircle,
  AlertTriangle,
  XCircle,
  Info,
  Loader2,
  Clock,
  FileText,
  PauseCircle,
  Circle,
  Archive,
  Activity,
  Send,
  Star,
  Pause,
  Rocket,
  CheckCheck,
  Ban,
  MinusCircle,
} from "lucide-react";
import { useDensityScale } from "../../../_hooks/useDensityScale";
import { formatText } from "../../../_utils/textFormatter";
import Tooltip from "../../tooltip/Tooltip";
import "./_status-tag.scss";

const getIcon = (type, size) => {
  const common = { size, strokeWidth: 2 };
  const map = {
    success: <CheckCircle {...common} />,
    default: <Star {...common} />,
    active: <Activity {...common} />,
    closed: <CheckCircle {...common} />,
    archive: <Archive {...common} />,
    warning: <AlertTriangle {...common} />,
    error: <XCircle {...common} />,
    info: <Info {...common} />,
    invite: <Send {...common} />,
    processing: <Loader2 {...common} className="status-tag__icon--spin" />,
    pending: <Clock {...common} />,
    draft: <FileText {...common} />,
    paused: <PauseCircle {...common} />,
    inactive: <Pause {...common} />,
    neutral: <Circle {...common} />,
    comingSoon: <Rocket {...common} />,
    paid: <CheckCheck {...common} />,
    writeoff: <Ban {...common} />,
    notApplicable: <MinusCircle {...common} />,
  };
  return map[type] || map.default;
};

export const StatusTag = ({
  type = "neutral",
  label,
  showIcon = true,
  title = "",
  noBorder = false,
  noBackground = false,
  pill = false,
}) => {
  const densityScale = useDensityScale();
  const classes = [
    "status-tag",
    `status-tag--${type}`,
    noBorder && "status-tag--no-border",
    noBackground && "status-tag--no-background",
    pill && "status-tag--pill",
  ]
    .filter(Boolean)
    .join(" ");
  const iconSize = Math.round(12 * densityScale);

  const statusContent = (
    <span className={classes} data-density={densityScale}>
      {showIcon && (
        <span
          className="status-tag__icon"
          style={{
            width: iconSize,
            height: iconSize,
          }}
        >
          {getIcon(type, iconSize)}
        </span>
      )}
      {formatText(label)}
    </span>
  );

  if (title && title.length > 0) {
    return (
      <Tooltip content={title} className="status-tag-tooltip-anchor">
        {statusContent}
      </Tooltip>
    );
  }

  return statusContent;
};
